export const CAN_MOCK_FEATURE_FLAG_KEY = 'canMockFeatureFlag';
